import * as focusTrap from 'focus-trap';
import { $html } from '../utils/dom';

export default class Header extends HTMLElement {
  static CLASS = {
    MODAL_OPEN: 'has-modal-open',
    MENU_OPEN: 'has-menu-open'
  };

  constructor() {
    super();

    this.$container = this.querySelector('[data-container]');
    this.$menu = document.querySelector('[data-header-menu]');
    // Поддерживаем несколько кнопок, которые открывают/закрывают одно и то же меню
    // (в т.ч. если одна кнопка в хедере, а другая, например, в меню).
    this.$menuTogglers = Array.from(document.querySelectorAll('[data-header-toggler]'));

    this.hasMenuOpen = false;
  }

  connectedCallback() {
    const trapElements = [this.$container, this.$menu].filter(Boolean);

    this.focusTrap = focusTrap.createFocusTrap(trapElements, {
      onActivate: this.onActivate,
      onDeactivate: this.onDeactivate,
      clickOutsideDeactivates: true
    });

    this.bindEvents();
    this.syncTogglersState();
  }

  disconnectedCallback() {
    this.unbindEvents();
    this.focusTrap?.deactivate?.();
  }

  bindEvents() {
    // На случай, если `header` смонтировался до появления каких-то элементов
    // (или Swup заменил контент), обновим список тогглеров.
    this.$menuTogglers = Array.from(document.querySelectorAll('[data-header-toggler]'));
    this.$menuTogglers.forEach($toggler =>
      $toggler.addEventListener('click', this.onMenuTogglerClick)
    );
  }

  unbindEvents() {
    this.$menuTogglers?.forEach?.($toggler =>
      $toggler.removeEventListener('click', this.onMenuTogglerClick)
    );
  }

  onMenuTogglerClick = event => {
    // Если клик пришёл по <span>/<svg> внутри кнопки — поднимемся до самой кнопки
    const toggler = event?.target?.closest?.('[data-header-toggler]') || null;

    const isOpen = $html.classList.contains(Header.CLASS.MENU_OPEN);

    // Синхронизируем состояние на всех кнопках
    this.setTogglersExpanded(!isOpen);

    if (isOpen) {
      this.focusTrap?.deactivate?.();
    } else {
      this.openMenu();
    }

    // Чтобы клик по кнопке не улетал в `clickOutsideDeactivates` в некоторых раскладках DOM
    toggler?.blur?.();
  };

  onActivate = () => {
    this.hasMenuOpen = true;
    $html.classList.add(Header.CLASS.MODAL_OPEN);
    this.setTogglersExpanded(true);
  };

  onDeactivate = () => {
    this.hasMenuOpen = false;
    $html.classList.remove(Header.CLASS.MODAL_OPEN, Header.CLASS.MENU_OPEN);
    this.setTogglersExpanded(false);
  };

  openMenu() {
    $html.classList.add(Header.CLASS.MENU_OPEN);

    if (this.focusTrap?.active) {
      this.onActivate();
    } else {
      this.focusTrap?.activate?.();
    }
  }

  setTogglersExpanded(isExpanded) {
    const value = isExpanded ? 'true' : 'false';
    this.$menuTogglers?.forEach?.($toggler => $toggler.setAttribute('aria-expanded', value));
  }

  syncTogglersState() {
    const isOpen = $html.classList.contains(Header.CLASS.MENU_OPEN);
    this.setTogglersExpanded(isOpen);
  }
}
